import React from 'react'

import styled from 'styled-components'
import { MarginProps, margin } from 'styled-system'
import { colors } from 'utils/colors'
type Props = {
  height?: string
  color?: string
} & MarginProps

const Element = styled.div<{ lineColor?: string; lineHeight?: string }>`
  display: block;
  clear: both;
  width: 100%;
  min-width: 100%;
  height: ${(p) => p.lineHeight || '1px'};
  background: ${(p) => p.lineColor || p.theme.colors.gray2};
  ${margin}
`
const colorDict = colors as { [key: string]: string }
const Divider: React.FC<Props> = ({ color, height, ...props }) => (
  <Element className="divider" lineColor={colorDict[color ? color : 'gray2']} lineHeight={height} {...props} />
)

export default Divider
